import React, { Component } from 'react';
import { Table, Modal, Button, message } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class ContractAttachment extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
    }
    
    show = record => {
        this.setState({
            record,
            visible: true
        }, () => {
            const { investigationId } = record;
            this.queryInvFinishInfo(investigationId, () => this.loadData());
        });
    }

    hide = () => {
        this.setState({
            data: [],
            visible: false,
            activeKey: 'advance',
        });
    }

    queryInvFinishInfo = (investigationId, callback) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.proContract.getInvTerminationApplyInfo,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data: { fileList } } = res;
                this.setState({
                    data: fileList,
                    loading: false,
                }, () => {
                    callback && callback();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    loadData = () => {
        const { record: { jdeApplyId } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'post',
            url: API_URL.contract.queryJdeApplyFileMetaById,
            data: {
                jdeApplyId,
                uploadType: 'CONTRACT',
            },
            dataType: 'json',
            doneResult: res => {
                const { data } = this.state;
                this.setState({
                    loading: false,
                    data: data.concat(res.data),
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    downLoadFile = (e, id) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({fileMetaId: id}, null, url);
    }

    getColumns = () => [{
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        width: 85,
    }, {
        title: '附件名称',
        dataIndex: 'name',
        key: 'name',
        width: 335,
        render: (text, record) => (
            <a onClick={e => this.downLoadFile(e, record.fileMateId)}>{text}</a>
        )
    }]

    getDateSource = () => {
        const { data = [] } = this.state;
        const dataSource = [];

        data.map((item, index) => {
            dataSource.push({
                index: index + 1,
                ...item,
            })
        });

        return dataSource;
    }

    getContent = () => {
        const { loading } = this.state;
        return (
            <div>
                <Table
                    columns={this.getColumns()}
                    dataSource={this.getDateSource()}
                    rowKey={record => record.index}
                    scroll={{x: 420}}
                    pagination={false}
                    loading={loading}
                />
                <div style={{ position: 'relative', top: -1, borderTop: '1px solid #e4e4e4' }} />
            </div>
        );
    }

    render () {
        const { visible, record: { investigationName } } = this.state;
        return (
            <Modal
                title="查看附件"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width="480px"
                footer={<Button type="primary" onClick={this.hide}>关 闭</Button>}
            >
                <div className="cont-cont contract-record" style={{margin: 20}}>
                    <div style={{ marginBottom: 16 }}>
                        项目简称：{investigationName}
                    </div>
                    {this.getContent()}
                </div>
            </Modal>
        );
    }
}

export { ContractAttachment };



// WEBPACK FOOTER //
// ./src/components/contractManagement/terminationApply/Widget.js